import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, INJECTOR, NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { Title } from '@angular/platform-browser';
import { DashboardComponent } from '@app/core/components/dashboard/dashboard.component';
import { CoreMenuModule } from '@app/core/core-menu.module';
import { CoreRoutingModule } from '@app/core/core-routing.module';
import { ApiRequestInterceptorService } from '@app/core/interceptors/api-request-interceptor.service';
import { AboutPageComponent } from '@app/core/pages/about-page/about-page.component';
import { FooterComponent } from '@app/core/pages/layout/footer/footer.component';
import { HeaderComponent } from '@app/core/pages/layout/header/header.component';
import { LayoutComponent } from '@app/core/pages/layout/layout.component';
import { LoginPageComponent } from '@app/core/pages/login-page/login-page.component';
import { UserProviderService } from '@app/core/services/user-provider.service';
import { LoginMethodsInitializer } from '@app/core/util/initializers/login-methods-initializer';
import { LogoutMethodInitializer } from '@app/core/util/initializers/logout-method-initializer';
import { StartupSessionInitializer } from '@app/core/util/initializers/startup-session-initializer';
import {
  AUTH_LOGIN_METHODS,
  AUTH_LOGOUT_METHOD,
  AuthenticationProviderService,
  BasicCredentialProviderService,
} from '@technocom/auth';
import { TkCommonModule } from '@technocom/common';
import {
  EnvironmentService,
  MainMenuService,
  NavigatorService,
  ServerSessionWatcherService,
  TkCoreModule,
} from '@technocom/core';
import { TkEntityModule } from '@technocom/data';
import { SharedModule } from '@app/shared/shared.module';
import { OamRemoteUserInterceptor } from '@app/core/interceptors/oam-remote-user.interceptor';
import { MobileDownloadPageComponent } from '@app/core/pages/mobile-download-page/mobile-download-page.component';
import { LoginPhonePageComponent } from '@app/core/pages/login-phone-page/login-phone-page.component';
import { RegistrationPageComponent } from '@app/core/pages/registration-page/registration-page.component';
import { RecoveryPageComponent } from '@app/core/pages/recovery-page/recovery-page.component';
import { CaptchaComponent } from '@app/core/components/captcha/captcha.component';
import { BackendInterceptorService } from '@app/core/services/backend-interceptor.service';
import { PreconditionInterceptor } from '@app/core/services/precondition-interceptor.service';

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    AboutPageComponent,
    LoginPageComponent,
    MobileDownloadPageComponent,
    LoginPhonePageComponent,
    RegistrationPageComponent,
    RecoveryPageComponent,
    CaptchaComponent,

    // more
  ],
  providers: [
    {
      provide: AuthenticationProviderService,
      useClass: UserProviderService,
    },
    {
      provide: APP_INITIALIZER,
      deps: [ServerSessionWatcherService],
      useFactory: StartupSessionInitializer,
      multi: true,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: BasicCredentialProviderService,
    //   multi: true,
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BackendInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PreconditionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiRequestInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OamRemoteUserInterceptor,
      multi: true,
    },
    {
      provide: AUTH_LOGIN_METHODS,
      deps: [INJECTOR],
      useFactory: LoginMethodsInitializer,
    },
    {
      provide: AUTH_LOGOUT_METHOD,
      deps: [INJECTOR],
      useFactory: LogoutMethodInitializer,
    },
  ],
  imports: [
    // SharedModule,
    CommonModule,
    MatButtonModule,
    // ТЕХНОКОМ
    TkCommonModule,
    TkEntityModule,
    TkCoreModule,
    // Проект
    CoreMenuModule,
    CoreRoutingModule,
    SharedModule,
    NgOptimizedImage,
  ],
  exports: [
    LayoutComponent,
    DashboardComponent,
    // more
  ],
})
export class CoreModule {
  constructor(router: NavigatorService, windowTitle: Title, menu: MainMenuService, env: EnvironmentService) {
    const title = env.context.displayName;
    const renewTitle = () => {
      // собираем заголовок из названий всех активных роутов
      let value = router.getTitleParts().join(ROUTE_SEPARATOR);

      // если заголовок не пуст, то добавляем особый разделитель перед
      // объединением с названием приложения
      if (value) {
        value += TITLE_SEPARATOR;
      }

      windowTitle.setTitle(value + title);
    };

    renewTitle();

    router.onChangeEvent.subscribe(renewTitle);
  }
}

const ROUTE_SEPARATOR = ' / ';
const TITLE_SEPARATOR = ' — ';
